interface IAloErrorConstParam  {
    errorMessage:string
    dataDic:{[id:string]:any}
    internalErrorMessage:string 
    securityStatus:string|null
}

export class AloError {
    
    public errorMessage:string
    public dataDic:{[id:string]:any}
    public internalErrorMessage:string    
    public securityStatus:SecurityStatus|null

    constructor({errorMessage='',dataDic,internalErrorMessage,securityStatus=null}:IAloErrorConstParam ) {
        this.errorMessage = errorMessage
        this.dataDic = dataDic        
        this.internalErrorMessage = internalErrorMessage
        this.securityStatus = securityStatus?securityStatus as SecurityStatus:null
    }
}

export enum SecurityStatus{
    Ok					= 'Ok',
    NoSuchLogin			= 'NoSuchLogin',
    BadPassword			= 'BadPassword',
    AccountDisabled		= 'AccountDisabled',

    // Token Validation
    TokenClearedForNewOne			= 'TokenClearedForNewOne',
    TokenIsEmpty					= 'TokenIsEmpty',
    InvalidTokenString				= 'InvalidTokenString',
    TokenInvalidSignature			= 'TokenInvalidSignature',
    TokenExpired					= 'TokenExpired',
    TokenNotYetValid				= 'TokenNotYetValid',
    TokenInvalidAudience			= 'TokenInvalidAudience',
    TokenInvalidIssuer				= 'TokenInvalidIssuer',
    TokenInvalidLifetime			= 'TokenInvalidLifetime',
    TokenNoExpiration				= 'TokenNoExpiration',
}